export default "__VITE_ASSET__DAfMNfZv__"